

export default {
data () {
return {
Value: this.value,
readonly: false
}
},
props: {
value: {
default: ''
}
},
methods: {
dateClick () {
let _this = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: '2017-05-20 18',
onConfirm (val) {
_this.Value = val
_this.$emit('update:value', val)
_this.$emit('change', val)
},
onShow () {

},
onHide () {

}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/simple/appDate/App-date.vue